import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class PricingService {
    http;
    constructor(http) {
        this.http = http;
    }
    evaluate(data) {
        return this.http.post(`${environment.base}/evaluate`, data);
    }
    static ɵfac = function PricingService_Factory(t) { return new (t || PricingService)(i0.ɵɵinject(i1.HttpClient)); };
    static ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: PricingService, factory: PricingService.ɵfac });
}
